import { createApp } from 'vue'
import UnitLesson from '../components/UnitLesson.vue'

export function mountUnitLesson() {
  const el = document.getElementById('unit-lesson-app')
  if (!el) return

  const app = createApp(UnitLesson, {
    unitId: parseInt(el.dataset.unitId),
    unitUrl: el.dataset.unitUrl,
    vocabUrl: el.dataset.vocabUrl,
    grammarUrl: el.dataset.grammarUrl,
    practiceUrl: el.dataset.practiceUrl,
  })
  app.mount(el)
}
